import { z } from 'zod';

export const zId = z.coerce.number();

export type Id = number;
